import { supabase } from "@/integrations/supabase/client";

interface GenerateInvitationLinkParams {
  invitationId: string;
  contactId: string;
  organizationId: string;
  invitedRole: string;
  email?: string;
}

/**
 * Generates the invitation URL for a contact, using the active
 * `user_invitation` URL template if available, otherwise the default
 * `/invite-contact` fallback URL. Mirrors the logic used in
 * ContactUserBridge when sending an invitation email.
 */
export async function generateInvitationLink({
  invitationId,
  contactId,
  organizationId,
  invitedRole,
  email,
}: GenerateInvitationLinkParams): Promise<string> {
  const { data: urlTemplateData } = await supabase
    .from("url_templates")
    .select("url_template")
    .eq("template_type", "user_invitation")
    .eq("is_active", true)
    .maybeSingle();

  const baseUrl = window.location.origin;

  if (urlTemplateData?.url_template) {
    const templateVariables: Record<string, string> = {
      baseUrl,
      invitationToken: invitationId,
      contactId,
      organizationId: organizationId || "",
      invitedRole: invitedRole || "standard",
      email: email ? encodeURIComponent(email) : "",
    };

    return Object.entries(templateVariables).reduce((result, [key, value]) => {
      const placeholder = `{{${key}}}`;
      return result.replace(new RegExp(placeholder, "g"), String(value ?? ""));
    }, urlTemplateData.url_template);
  }

  return `${baseUrl}/invite-contact?token=${invitationId}&contact_id=${contactId}`;
}
